import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export enum TagVariant {
  BLUE = 'blue',
  GRAY = 'gray',
  GREEN = 'green',
  PURPLE = 'purple',
  RED = 'red',
  WHITE = 'white',
  YELLOW = 'yellow',
}

const tagVariantCSS: Record<TagVariant, string> = {
  [TagVariant.WHITE]: 'border-gray-100 bg-white text-gray-500',
  [TagVariant.GREEN]: 'border-forest-200 bg-forest-50 text-forest-600',
  [TagVariant.BLUE]: 'border-brand-200 bg-brand-50 text-brand-700',
  [TagVariant.RED]: 'border-fireside-200 bg-fireside-50 text-fireside-600',
  [TagVariant.GRAY]: 'border-gray-100 bg-gray-100 text-gray-500',
  [TagVariant.YELLOW]: 'border-[#FFFAEB] bg-[#FFFAEB] text-[#B54708]',
  [TagVariant.PURPLE]: 'border-[#7F56D9] bg-[#7F56D9] text-[#FCFAFF]',
};

export type TagProps = {
  callback?: () => void;
  className?: string;
  icon?: ReactNode;
  title: ReactNode | string;
  variant?: TagVariant;
} & Optional<{
  borderColor: string;
}>;

export const Tag: FC<TagProps> = ({
  title,
  variant = TagVariant.GREEN,
  borderColor,
  className,
  callback,
  icon,
}) => {
  return (
    <span
      className={twMerge(
        'flex h-fit w-fit items-center gap-1 whitespace-nowrap rounded-2xl px-2 py-[2px] !text-label-md !font-medium',
        tagVariantCSS[variant],
        variant === TagVariant.WHITE && 'border',
        borderColor,
        className,
      )}
      onClick={callback}
    >
      {icon}
      {title}
    </span>
  );
};
